import * as React from "react";
const SvgMinusMedium = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M15.834 9.25a.75.75 0 0 1 0 1.5H4.167a.75.75 0 1 1 0-1.5z" /></svg>;
export default SvgMinusMedium;